import { Component, Inject, OnInit } from '@angular/core';
import { ContractsOverageDataSource, FindContractOveragesRequest } from '../../data-table/datasource/contracts-overage-datasource';
import { ContractOverage, GlobalTenantContractsApi } from 'src/app/usage-api';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { Router } from '@angular/router';

@Component({
  selector: 'app-contracts-overage-list-view',
  templateUrl: './contracts-overage-list-view.component.html',
  styleUrls: ['./contracts-overage-list-view.component.scss'],
  standalone: false
})
export class ContractsOverageListViewComponent implements OnInit {
    dataSource: ContractsOverageDataSource;
    title = 'BackOffice.ManageContracts.ContractOverages';
    contractId: string = null;
    tenantId: number = null;

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private readonly globalTenantContractsApi: GlobalTenantContractsApi,
    public router: Router,
  ) { }

  ngOnInit() {
    const findContractRequest: FindContractOveragesRequest = {
      searchAllTenants: true,
      onlyActiveTenants: true
    }

    this.dataSource = new ContractsOverageDataSource(this.globalTenantContractsApi, null, null, findContractRequest, false);
    this.dataSource.loadData(true);
  }

  onRowClicked(row: ContractOverage): void {
    this.router.navigate(
      ['/back-office/contracts', row.tenantId, row.contractId],
      {
        queryParams: { tab: 'usage-overages' },
        queryParamsHandling: 'merge'
      }
    );
  }
}
